export enum Permissions {
  READ = 'READ',
  WRITE = 'WRITE',
}
